module.exports = __webpack_public_path__ + "img/circle.68af371c.png";